import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NavbarService } from '../service/navbar.service';
import { AdminNavbarComponent } from '../component/admin-navbar/admin-navbar.component';
import { FixedTopProgressBarComponent } from '../component/fixed-top-progress-bar/fixed-top-progress-bar.component';
import { InfoService } from '../service/info.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit, OnDestroy {
  /** True quando a rota ativa pede layout full-bleed (a landing/shell do menu
   *  lateral). Liga `.has-side-nav` no shell, esconde a navbar e zera o padding
   *  centralizador do `.container`. */
  isFullBleed = false;

  private sub?: Subscription;

  // ViewChild via setter porque navbar e progress-bar são renderizados sob
  // `*ngIf` (mutuamente exclusivos por rota): quando o elemento aparece, o
  // setter dispara e registramos o alvo no NavbarService.
  // - Fora da landing: a navbar provê o progress bar (setNavbar lê navbar.progressBar).
  // - Na landing (sem navbar): registramos diretamente o progress bar do shell.
  @ViewChild('navbar') set navbarRef(navbar: AdminNavbarComponent | undefined) {
    if (navbar) {
      this.navbarService.setNavbar(navbar);
    }
  }

  @ViewChild('fbProgress') set progressRef(bar: FixedTopProgressBarComponent | undefined) {
    if (bar) {
      this.navbarService.progressBar = bar;
    }
  }

  constructor(
    private navbarService: NavbarService,
    private router: Router,
    private route: ActivatedRoute,
    public infoService: InfoService,
  ) { }

  ngOnInit() {
    this.updateFullBleed();
    this.sub = this.router.events.subscribe(e => {
      if (e instanceof NavigationEnd) {
        this.updateFullBleed();
      }
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  /** Varre a cadeia de rotas ativas e liga o full-bleed se QUALQUER segmento
   *  carregar o flag `adminFullBleed` (a herança 'emptyOnly' do router já
   *  propagaria via o pai de path vazio, mas varrer é robusto a mudanças). */
  private updateFullBleed(): void {
    let r: ActivatedRoute | null = this.route;
    let full = false;
    while (r) {
      if (r.snapshot.data && r.snapshot.data.adminFullBleed) {
        full = true;
        break;
      }
      r = r.firstChild;
    }
    this.isFullBleed = full;
  }
}
